// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "static/css/" + chunkId + "." + {"1":"a6877dfc","976":"7208dd8f"}[chunkId] + ".chunk.css"; };